import styled from 'styled-components'

export const ElectionLogo = styled.img`
  display: flex;
  width: 64px;
  height: 64px;
`
